<h2 mat-dialog-title style="margin-bottom: 5px">Send Test Email</h2>
<mat-dialog-content>
    <tyl-form-field style="width: 100%" label="Send Test to">
        <input matInput type="text" #EmailAddress id="txtEmailAddress" [(ngModel)]="userEmailAddress"
               aria-label="Send Test to"/>
    </tyl-form-field>
  <!-- <input #EmailAddress id="txtEmailAddress" matInput [(ngModel)]="userEmailAddress" /> -->
</mat-dialog-content>
<mat-dialog-actions>
  <div class='flex-footer-right'>
    <error-prompt [errorList]="errors"></error-prompt>
    <tyl-button image="save.png" label="Send Test" (clickEvent)="sendTestClick()"></tyl-button>
    <tyl-button image="Cancel.png" label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
  </div>
</mat-dialog-actions>